import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';


@Injectable({
  providedIn: 'root'
})
export class DatatransferService {
  private valueSubject = new Subject<any>(); // Replace 'string' with your data type
  value$ = this.valueSubject.asObservable();

  setValue(value: any) {
    this.valueSubject.next(value);
  }

  private messageSource = new BehaviorSubject<any>('');
  currentMessage = this.messageSource.asObservable();

  private teamSource = new BehaviorSubject<any>('');
  teamMessage = this.teamSource.asObservable();


  private teamLisingSource = new BehaviorSubject<any>('');
  teamLisingMessage = this.teamLisingSource.asObservable();

  private teamListUpdateSource = new BehaviorSubject<boolean>(false);
  teamListUpdateMessage = this.teamListUpdateSource.asObservable();

  private teamMemnerSource = new BehaviorSubject<any>('');
  teamMemberMessage = this.teamMemnerSource.asObservable();

  // for update user listing
  private userLisingSource = new BehaviorSubject<any>('');
  userLisingMessage = this.userLisingSource.asObservable();


  // for User,Team, Product counts
  private ViewPageCounts = new BehaviorSubject<any>('');
  ViewPageCountsMessage = this.ViewPageCounts.asObservable();


  private selectedTeamId = new BehaviorSubject<any>('');
  selectedTeamId$ = this.selectedTeamId.asObservable();

  constructor() { }

  sendDataBetweenComponents(data: any) {
    this.messageSource.next(data);
  }

  sendDataBetweenComponentsForTeam(data: any) {
    this.teamSource.next(data);
  }

  sendDataBetweenComponentsForTeamListing(data: any) {
    this.teamLisingSource.next(data);
  }

  sendDataBetweenComponentsForUpdateTeamList(isUpdate: boolean) {
    this.teamListUpdateSource.next(isUpdate);
  }

  sendDataBetweenComponentsForTeamMember(data: any) {
    this.teamMemnerSource.next(data);
  }

  sendDataBetweenComponentsForUserListing(data: any) {
    this.userLisingSource.next(data);
  }

  sendDataBetweenComponentsCLientViewPageCounts(data: any) {
    this.ViewPageCounts.next(data);
  }
}
